import Star_20 from '../assets/Star_20.svg'
import Star_22 from '../assets/Star_22.svg'
// import Star_24 from '../assets/Star_24.svg'
// import Star_25 from '../assets/Star_25.svg'
// import Star_26 from '../assets/Star_26.svg'

const PromoBanner = () => {
  return (
    // D1.1.3: exactly 96px on desktop. Mobile keeps min-height so the two lines of copy
    // can wrap without being clipped.
    <div className="min-h-[96px] md:h-[96px] py-5 md:py-0 px-4 bg-brand-dark overflow-hidden relative">
      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_#4CBC18,_transparent_60%)]" />

      {/* Star positions measured off the banner design export (1440px wide, 96px tall):
          left cluster = 22px @ 18.9%/top 29 + 8px @ 18%/top 62;
          right cluster = 10px @ 14.3%/top 27, 5px @ 13.9%/top 38, 20px @ 15.6%/top 46. */}
      {/* M1.1.1 — "Relocate the stars (it's overlapping with the text)". The positions
          below md are percentages taken off the 1440px banner export, so on a phone ~18%
          and ~14% land inside the headline. Moved out to the bezels on mobile, where the
          centred copy leaves room; the desktop percentages are untouched. */}
      {/* left star cluster */}
      <img src={Star_20} alt="" aria-hidden className="absolute left-[6px] md:left-[18.9%] top-[24px] md:top-[29px] w-[14px] md:w-[22px] opacity-90" />
      <img src={Star_22} alt="" aria-hidden className="absolute left-[16px] md:left-[18%] top-[58px] md:top-[62px] w-[6px] md:w-[8px] opacity-40" />

      {/* right star cluster */}
      <img src={Star_20} alt="" aria-hidden className="absolute right-[8px] md:right-[14.3%] top-[22px] md:top-[27px] w-[8px] md:w-[10px] opacity-90" />
      <img src={Star_22} alt="" aria-hidden className="absolute right-[6px] md:right-[13.9%] top-[36px] md:top-[38px] w-[5px] opacity-40" />
      <img src={Star_22} alt="" aria-hidden className="absolute right-[14px] md:right-[15.6%] top-[50px] md:top-[46px] w-[13px] md:w-[20px] opacity-40" />

      <div className="relative h-full flex flex-col items-center justify-center text-center">
        <h3 className="text-[18px] md:text-[20px] font-extrabold text-white">
          <span className="text-brand-green">50% Off Lifetime</span> for Founding Users!
        </h3>

        <p className="text-white/80 mt-1 text-[13px] md:text-[14px] italic">
          Limited to the first 100 Pro annual subscribers.
        </p>
      </div>
    </div>
  )
}

export default PromoBanner